import type { documentTableOptions } from "./documentTableOptions";
import type { useTableBasics } from "./useTableBasics";
import type { useTableSelectionState } from "./useTableSelectionState";
type Options = Pick<
  ReturnType<typeof documentTableOptions>,
  | "currentPage"
  | "totalCount"
  | "paginationPageSize"
  | "onPageChange"
  | "unfilteredTotalCount"
  | "isRefreshing"
> &
  Pick<ReturnType<typeof useTableBasics>, "t"> &
  Pick<ReturnType<typeof useTableSelectionState>, "hasRenderedTable">;
export function createTablePagination(options: Options) {
  const {
    currentPage,
    totalCount,
    paginationPageSize,
    onPageChange,
    unfilteredTotalCount,
    t,
    isRefreshing,
    hasRenderedTable,
  } = options;
  // Whether server-side pagination is active
  const paginationProps = tablePagination(options);
  const showPaginationControls =
    paginationProps !== null && paginationProps.totalItems > paginationProps.pageSize;
  const resultCountLabel =
    totalCount === undefined
      ? null
      : unfilteredTotalCount === undefined
        ? t.documents.folder.documentCount.replace("{count}", totalCount.toLocaleString())
        : t.documents.filters.showing
            .replace("{filtered}", totalCount.toLocaleString())
            .replace("{total}", unfilteredTotalCount.toLocaleString());
  const showLoadingOverlay = isRefreshing && hasRenderedTable;
  return { showLoadingOverlay, resultCountLabel, showPaginationControls, paginationProps };
}

function tablePagination(options: Options) {
  const { currentPage, totalCount, paginationPageSize, onPageChange } = options;
  const paginationProps =
    currentPage !== undefined &&
    totalCount !== undefined &&
    paginationPageSize !== undefined &&
    onPageChange !== undefined
      ? {
          currentPage,
          totalItems: totalCount,
          pageSize: paginationPageSize,
          onPageChange,
        }
      : null;
  return paginationProps;
}
